// extracted by mini-css-extract-plugin
module.exports = {"container":"TwoColumnText_container__enNWa","leftColumn":"TwoColumnText_leftColumn__a_W2i","rightColumn":"TwoColumnText_rightColumn__rq3b0"};